import React, { useEffect, useState } from 'react';
import {
    Button,
    notification,
    Space,
    Form,
    Select,
    Row,
    Col,
    Input,
    Alert,
    Modal,
} from 'antd';
import API_SERVICE from '../../../services/api-service';
import './index.scss';
import {
    ArrowLeftOutlined,
    DownloadOutlined,
    FileExcelOutlined,
    ImportOutlined,
    FileTextOutlined,
} from '@ant-design/icons';
import pound from 'shared/assets/icons/active_pound.png';
import { CLAIMS_OVERVIEW } from 'shared/constants/RouteConstants';
import EmployeesCost from './EmployeesCost/EmployeesCost';
import SubContractor from './SubContractor/SubContractor';
import ExternalWorkers from './ExternalWorkers/ExternalWorkers';
import Consumables from './Consumables/Consumables';
import { useTranslation } from 'react-i18next';
import { BulkUpload } from '../../../components';
import BulkUploadListModal from '../../../components/BulkUploadListModal';
import XeroFetchModal from './Xero/EmployeeCost/XeroFetchModal';

export default function FinancialDetailsPage(props: any) {
    const { t } = useTranslation();

    const [tableType, setTableType] = useState({} as any);
    const [claimId, setClaimId] = useState(null);
    const [claimDetails, setClaimDetails] = useState({} as any);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isXeroModalVisible, setIsXeroModalVisible] = useState(false);
    const [bulkUploadModal, setBulkUploadModal] = useState(false);
    const [bulkUploadedData, setBulkUploadedData] = useState([] as any);
    const [bulkUploadedURL, setBulkUploadedURL] = useState([] as any);
    const [xeroAuthStatus, setXeroAuthStatus] = useState(false);
    const [xeroTabledata, setXeroTabledata] = useState([] as any);
    const [descriptionDetails, setDescriptionDetails] = useState({
        descriptionEmployeeCost: '',
        descriptionExternalWorkersCost: '',
        descriptionSubContractorsData: '',
        descriptionConsumablesData: '',
        descriptionSoftwareConsumables: '',
    });

    const showBulkUploadModal = (data: any, downloadUrl: any) => {
        setBulkUploadedData(data);
        setBulkUploadedURL(downloadUrl);
        setBulkUploadModal(true);
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setIsXeroModalVisible(false);
    };

    const handleTableTypeChange = (value: any) => {
        setTableType(value);
    };

    const handlePulldata = (data: any) => {
        if (tableType === 'esc') {
            setXeroTabledata(data);
        }

        // will be enable later
        /*else if(tableType === 'scr') {
           setXeroTabledata(data);
       } else if(tableType === 'ewc') {
           setXeroTabledata(data);
       } else if(tableType === 'cms') {
           setXeroTabledata(data);
       }*/
    };

    const handleXeroClick = async () => {
        claimId &&
            claimDetails &&
            claimDetails.companyId &&
            true &&
            setIsXeroModalVisible(true);
    };

    const goBackToOverview = () => {
        const id = claimId || (props.match && props.match.params && props.match.params.claimId);
        if (id) {
            props.history.push(`${CLAIMS_OVERVIEW}/${id}`);
        }
    };

    const downdloadSample = async () => {
        try {
            if (tableType === 'esc') {
                // @ts-ignore
                window.open(
                    API_SERVICE.downloadEmoployeeCostSampleSheet(claimId),
                );
            } else if (tableType === 'scr') {
                window.open(
                    API_SERVICE.downloadSubContractorCostSampleSheet(claimId),
                );
            } else if (tableType === 'ewc') {
                window.open(
                    API_SERVICE.downloadExternalWorkerCostSampleSheet(claimId),
                );
            } else if (tableType === 'cms') {
                window.open(
                    API_SERVICE.downloadConsumablesCostSampleSheet(claimId),
                );
            } else if (tableType === 'soft') {
                window.open(
                    API_SERVICE.downloadSoftwareConsumablesCostSampleSheet(claimId),
                );
            }
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        }
    };

    const checkIsXeroAuthenticated = async () => {
        if (claimDetails && claimDetails.companyId) {
            try {
                const {
                    data: { data },
                } = await API_SERVICE.checkXeroAuthStatus({
                    companyId: claimDetails.companyId,
                });
                setXeroAuthStatus(data.status);
            } catch (e) {
                notification.error({ message: API_SERVICE.handleErrors(e) });
            }
        }
    };

    const setDescription = async (value: any) => {
        try {
            if (tableType === 'esc') {
                await API_SERVICE.financialEmployeeCostDescriptionUpdate(
                    claimId,
                    value,
                );
            } else if (tableType === 'scr') {
                await API_SERVICE.financialSubContractorCostDescriptionUpdate(
                    claimId,
                    value,
                );
            } else if (tableType === 'ewc') {
                await API_SERVICE.externalWorkerCostDescriptionUpdate(
                    claimId,
                    value,
                );
            } else if (tableType === 'cms') {
                await API_SERVICE.financialConsumablesCostDescriptionUpdate(
                    claimId,
                    value,
                );
            } else if (tableType === 'soft') {
                await API_SERVICE.softwareConsumablesCostDescriptionUpdate(
                    claimId,
                    value,
                );
            }   
            notification.success({
                message: 'Description Updated',
            });
            handleCancel();
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        }
    };

    const getClaimsDetails = async (cId: any) => {
        try {
            const {
                data: { data },
            } = await API_SERVICE.getClaimById(cId);
            setClaimDetails(data);
            setDescriptionDetails({
                descriptionEmployeeCost: data.descriptionEmployeeCost,
                descriptionExternalWorkersCost:
                    data.descriptionExternalWorkersCost,
                descriptionSubContractorsData:
                    data.descriptionSubContractorsData,
                descriptionConsumablesData: data.descriptionConsumablesData,
                descriptionSoftwareConsumables: data.descriptionSoftwareConsumables,
            });
        } catch (e) {
            notification.error({ message: API_SERVICE.handleErrors(e) });
        }
    };

    useEffect(() => {
        setTableType('esc');
        const {
            match: { params },
        } = props;
        setClaimId(params.claimId);
        getClaimsDetails(params.claimId);
    }, []);

    useEffect(() => {
        checkIsXeroAuthenticated();
    }, [claimDetails]);

    useEffect(() => {
        const onFocus = () => {
            checkIsXeroAuthenticated();
        };
        window.addEventListener('focus', onFocus);
        return () => {
            window.removeEventListener('focus', onFocus);
        };
    }, [claimDetails]);


    interface TableInfo {
        message: string;
        description: React.ReactNode;
    }
    
    const financialDetailsTablePromptMessageAndDescription: Record<string, TableInfo> = {
        esc: {
            message: 'Enter total staffing costs related to eligible R&D work. This should include gross salaries, employer NICs, and employer pension contributions for staff directly and actively engaged in R&D. Exclude dividends, benefits-in-kind, or time spent on non-R&D work.',
            description: (
                <span>
                    For more detail, refer to the official HMRC guidance on R&D staffing costs:{' '}
                    <a href="https://www.gov.uk/hmrc-internal-manuals/corporate-intangibles-research-and-development-manual/cird83200" target="_blank" rel="noopener noreferrer">
                        HMRC CIRD83200 – Staff Costs
                    </a>
                </span>
            )
        },
        scr: {
            message: 'Enter payments made to subcontractors who carried out R&D on your behalf. HMRC Guidance – Subcontracted R&D (CIRD84250)',
            description: (
                <span>
                    For more detail, refer to the official HMRC guidance on subcontracted R&D:{' '}
                    <a href="https://www.gov.uk/hmrc-internal-manuals/corporate-intangibles-research-and-development-manual/cird84250" target="_blank" rel="noopener noreferrer">
                        HMRC CIRD84250 – Subcontracted R&D
                    </a>
                </span>
            )
        },
        ewc: {
            message: 'Enter costs for workers supplied by an external staff provider who were directly involved in R&D activities.',
            description: (
                <span>
                    For more detail, refer to the official HMRC guidance on Externally Provided Workers (EPWs):{' '}
                    <a href="https://www.gov.uk/hmrc-internal-manuals/corporate-intangibles-research-and-development-manual/cird82100" target="_blank" rel="noopener noreferrer">
                        HMRC CIRD82100 – Externally Provided Workers
                    </a>
                </span>
            )
        },
        cms: {
            message: 'Enter the cost of materials and utilities that were consumed or transformed during eligible R&D activities.',
            description: (
                <span>
                    Include:<br/>
                    • Raw materials used in building prototypes (not sold)<br/>
                    • A portion of utilities (e.g., electricity, gas, water) used directly in R&D<br/><br/>
                    For more detail, refer to the official HMRC guidance on consumable items:{' '}
                    <a href="https://www.gov.uk/hmrc-internal-manuals/corporate-intangibles-research-and-development-manual/cird83250" target="_blank" rel="noopener noreferrer">
                        HMRC CIRD83250 – Consumables Guidance
                    </a>
                </span>
            )
        },
        soft: {
            message: 'Enter costs of software directly used for R&D. Please break it down into software licence, data licence and cloud computing.',
            description: (
                <span>
                    <a
                        href="https://www.gov.uk/hmrc-internal-manuals/corporate-intangibles-research-and-development-manual/cird81960"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        CIRD81960 - R&D tax relief: conditions to be satisfied: BIS Guidelines (formerly DTI Guidelines) (2004) - application to software - HMRC internal manual - GOV.UK
                    </a>
                </span>
            )
        }
    }

    return (
        <div className={`financial-details-wrapper page-wrapper `}>
            <div>
                <Button
                    className="back-link-button"
                    shape="round"
                    icon={<ArrowLeftOutlined />}
                    onClick={goBackToOverview}
                >
                    Back to Claim Overview
                </Button>

                <div className="financial-header">
                    <div className="financial-header__title">
                        <img
                            src={pound}
                            alt="pound"
                            style={{
                                height: '35px',
                                marginRight: '7px',
                            }}
                        />
                        Financial Details
                    </div>
                    <Form className="financial-header__select">
                        <Row gutter={20}>
                            <Col flex={'auto'}>
                                <Form.Item
                                    name="tableType"
                                    style={{ marginBottom: 0 }}
                                >
                                    <Select
                                        showArrow={true}
                                        showSearch={false}
                                        defaultValue={'esc'}
                                        onSelect={handleTableTypeChange}
                                    >
                                        <Select.Option value={'esc'}>
                                            STAFFING COST
                                        </Select.Option>
                                        <Select.Option value={'scr'}>
                                            SUB-CONTRACTOR R&D
                                        </Select.Option>
                                        <Select.Option value={'ewc'}>
                                            EXTERNALLY PROVIDED WORKERS (EPW)
                                        </Select.Option>
                                        <Select.Option value={'cms'}>
                                            CONSUMABLES R&D
                                        </Select.Option>
                                        <Select.Option value={'soft'}>
                                            SOFTWARE COSTS
                                        </Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    <div className="financial-header__actions">
                        <div className="financial-header__action-group">
                            <Space>
                                <Form>
                                    <Form.Item
                                        className={'mb-0'}
                                        label={''}
                                        name={'file'}
                                    >
                                        <BulkUpload
                                            claimId={claimId}
                                            tableType={tableType}
                                            callback={showBulkUploadModal}
                                        >
                                            <Button
                                                disabled={
                                                    claimDetails.stageId >= 2
                                                }
                                                shape="round"
                                                className="black-button my-3"
                                                icon={<FileExcelOutlined />}
                                            >
                                                Bulk Upload
                                            </Button>
                                        </BulkUpload>
                                    </Form.Item>
                                </Form>

                                <Button
                                    disabled={claimDetails.stageId >= 2}
                                    shape="round"
                                    onClick={downdloadSample}
                                    className="black-button my-3"
                                    icon={<DownloadOutlined />}
                                >
                                    Sample
                                </Button>
                            </Space>
                        </div>

                        <div className="financial-header__action-group">
                            {xeroAuthStatus ? (
                                <Button
                                    shape="round"
                                    htmlType={'button'}
                                    className="black-button my-3"
                                    icon={<ImportOutlined />}
                                    onClick={handleXeroClick}
                                >
                                    Import from Xero
                                </Button>
                            ) : (
                                <Button
                                    disabled={claimDetails.stageId >= 2}
                                    shape="round"
                                    htmlType={'button'}
                                    className="black-button my-3"
                                    icon={<ImportOutlined />}
                                    onClick={() => {
                                        window.open(
                                            API_SERVICE.getXeroConnectUrl(claimDetails.companyId),
                                            '_blank',
                                        );
                                    }}
                                >
                                    Import from Xero
                                </Button>
                            )}
                        </div>
                        <div className="financial-header__action-group">
                            <Button
                                disabled={claimDetails.stageId >= 2}
                                shape="round"
                                className="black-button my-3"
                                icon={<FileTextOutlined />}
                                onClick={showModal}
                            >
                                Add Description
                            </Button>
                        </div>
                    </div>
                </div>
                <Alert
                    message={financialDetailsTablePromptMessageAndDescription[tableType]?.message || ''}
                    description={
                        financialDetailsTablePromptMessageAndDescription[tableType]?.description || ''
                    }
                    type="info"
                    showIcon
                    style={{ marginBottom: 16 }}
                />
                {/*<EditableTable />*/}
                {tableType === 'esc' && (
                    <EmployeesCost xeroTabledata={xeroTabledata} />
                )}
                {tableType === 'scr' && <SubContractor />}
                {tableType === 'ewc' && <ExternalWorkers />}
                {tableType === 'cms' && <Consumables type="cms" />}
                {tableType === 'soft' && <Consumables type="soft" />}
            </div>

            <Modal
                title="Add Description"
                footer={null}
                visible={isModalVisible}
                onCancel={handleCancel}
            >
                <Form
                    className={'forgot-password-form'}
                    fields={[]}
                    onFinish={setDescription}
                    requiredMark={false}
                    layout={'vertical'}
                    initialValues={descriptionDetails}
                >
                    {tableType === 'esc' && (
                        <Form.Item
                            style={{ flex: 1 }}
                            name="descriptionEmployeeCost"
                        >
                            <Input.TextArea
                                autoComplete={'off'}
                                placeholder="Add description here..."
                                rows={4}
                            />
                        </Form.Item>
                    )}

                    {tableType === 'scr' && (
                        <Form.Item
                            style={{ flex: 1 }}
                            name="descriptionSubContractorsData"
                        >
                            <Input.TextArea
                                autoComplete={'off'}
                                placeholder="Add description here..."
                                rows={4}
                            />
                        </Form.Item>
                    )}

                    {tableType === 'ewc' && (
                        <Form.Item
                            style={{ flex: 1 }}
                            name="descriptionExternalWorkersCost"
                        >
                            <Input.TextArea
                                autoComplete={'off'}
                                placeholder="Add description here..."
                                rows={4}
                            />
                        </Form.Item>
                    )}

                    {tableType === 'cms' && (
                        <Form.Item
                            style={{ flex: 1 }}
                            name="descriptionConsumablesData"
                        >
                            <Input.TextArea
                                autoComplete={'off'}
                                placeholder="Add description here..."
                                rows={4}
                            />
                        </Form.Item>
                    )}

                    {tableType === 'soft' && (
                        <Form.Item
                            style={{ flex: 1 }}
                            name="descriptionSoftwareConsumables"
                        >
                            <Input.TextArea
                                autoComplete={'off'}
                                placeholder="Add description here..."
                                rows={4}
                            />
                        </Form.Item>
                    )}

                    <Form.Item>
                        <div className="text-right">
                            <Space>
                                <Button
                                    className="black-button"
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="primary"
                                    shape="round"
                                    htmlType="submit"
                                    className="theme-button primary"
                                >
                                    update
                                </Button>
                            </Space>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>

            {isXeroModalVisible && (
                <XeroFetchModal
                    claimId={claimId}
                    companyId={claimDetails.companyId}
                    callback={handlePulldata}
                    onClose={(e: boolean) => {
                        if (e) {
                            // refresh();
                        }
                        setIsXeroModalVisible(false);
                    }}
                />
            )}

            <BulkUploadListModal
                bulkUploadModal={bulkUploadModal}
                tableType={tableType}
                claimDetails={claimDetails}
                data={bulkUploadedData}
                url={bulkUploadedURL}
                callback={(a: boolean) => {
                    setBulkUploadModal(false);
                    if (a) {
                        setTableType(tableType);
                    }
                }}
            />
        </div>
    );
}
